export default __webpack_public_path__ + "static/media/ic_logout.d35539da.svg";